import React, { useMemo } from "react";
import { motion } from "framer-motion";
import {
  CheckCircle2,
  XCircle,
  Clock,
  StopCircle,
  Loader2,
  Circle,
} from "lucide-react";

const LABELS = {
  idle:      "Idle",
  running:   "Running",
  success:   "Success",
  error:     "Error",
  stopped:   "Stopped",
  timed_out: "Timed out",
};

const CLASSES = {
  idle:      "text-ide-mute   border-ide-border       bg-ide-panel",
  running:   "text-sky-300    border-sky-500/40       bg-sky-500/10",
  success:   "text-emerald-300 border-emerald-500/40  bg-emerald-500/10",
  error:     "text-rose-300   border-rose-500/40      bg-rose-500/10",
  stopped:   "text-fuchsia-300 border-fuchsia-500/40  bg-fuchsia-500/10",
  timed_out: "text-amber-300  border-amber-500/40     bg-amber-500/10",
};

function Icon({ status }) {
  const cls = "h-3.5 w-3.5";
  switch (status) {
    case "running":   return <Loader2 className={cls + " animate-spin"} />;
    case "success":   return <CheckCircle2 className={cls} />;
    case "error":     return <XCircle className={cls} />;
    case "stopped":   return <StopCircle className={cls} />;
    case "timed_out": return <Clock className={cls} />;
    default:          return <Circle className={cls} />;
  }
}

export default function StatusPill({ status, execTimeMs, exitCode }) {
  const label = LABELS[status] || "Idle";
  const cls = CLASSES[status] || CLASSES.idle;
  const right = useMemo(() => {
    if (status === "running" || status === "idle") return null;
    if (typeof execTimeMs === "number" && execTimeMs >= 0) {
      return `${execTimeMs} ms`;
    }
    return null;
  }, [status, execTimeMs]);

  return (
    <motion.div
      initial={false}
      layout
      transition={{ duration: 0.18 }}
      className={
        "flex items-center gap-2 px-2.5 py-1 rounded-full border text-xs font-mono select-none transition-colors " +
        cls
      }
      style={{ minWidth: 96 }}
      data-status={status}
    >
      <Icon status={status} />
      <span>{label}</span>
      {typeof exitCode === "number" && status !== "idle" && status !== "running" && (
        <span className="text-[11px] opacity-70">exit {exitCode}</span>
      )}
      {right && <span className="text-[11px] opacity-70">{right}</span>}
    </motion.div>
  );
}
